import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { RevealDirective } from '../../core/directives/reveal.directive';
import { IconComponent, HxIconName } from '../../core/icons/icon.component';

interface Solution {
  icon: HxIconName;
  title: string;
  body: string;
}

@Component({
  selector: 'hx-solutions',
  standalone: true,
  imports: [MatCardModule, RevealDirective, IconComponent],
  template: `
    <section>
      <div class="wrap">
        <div class="section-head reveal" appReveal>
          <p class="eyebrow">Solutions</p>
          <h2>Everything from the ground up, or one piece at a time.</h2>
          <p>We plug in wherever you need us — as a full delivery team, or to extend the one you already have.</p>
        </div>

        <div class="grid-3">
          @for (item of solutions; track item.title) {
            <div class="reveal" appReveal>
              <mat-card class="card" appearance="outlined" style="border:none">
                <mat-card-content style="padding:0">
                  <div class="card-icon">
                    <hx-icon [name]="item.icon"></hx-icon>
                  </div>
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.body }}</p>
                </mat-card-content>
              </mat-card>
            </div>
          }
        </div>
      </div>
    </section>
  `,
})
export class SolutionsComponent {
  solutions: Solution[] = [
    {
      icon: 'cloud',
      title: 'Cloud Infrastructure',
      body: 'Provisioning, networking, and environment management across AWS, Microsoft Azure, and Google Cloud — built for scale from the first deploy, not retrofitted later.',
    },
    {
      icon: 'card',
      title: 'Payment Gateway Systems',
      body: 'End-to-end payment portals — merchant onboarding, transaction dashboards, and reconciliation, built to move money reliably.',
    },
    {
      icon: 'grid',
      title: 'Custom Dashboards & Portals',
      body: 'Internal tools and admin consoles designed around how your team actually works, not a generic template.',
    },
    {
      icon: 'integration',
      title: 'Systems Integration',
      body: 'Cards, QRPH, and third-party APIs wired into your existing stack — tested, monitored, and documented.',
    },
    {
      icon: 'shield',
      title: 'Security & Monitoring',
      body: 'Access control, encrypted sessions, and always-on monitoring so issues get caught before your users notice.',
    },
    {
      icon: 'support',
      title: 'Ongoing Support',
      body: 'Dedicated delivery teams that stay on after launch — for fixes, iteration, and the next phase of the build.',
    },
  ];
}
